import {
    GET_RESTRICTED_ACCOUNT,
    CREATE_RESTRICTED_ACCOUNT,
    UPDATE_RESTRICTED_ACCOUNT_STATUS,
    DELETE_RESTRICTED_ACCOUNT,
    OPEN_RESTRICTED_ACCOUNT_DIALOG,
    CLOSE_RESTRICTED_ACCOUNT_DIALOG,
} from "./types";

const initialState = {
    restrictedAccounts: [],
    dialog: false,
    dialogData: null,
};

const restrictedAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RESTRICTED_ACCOUNT:
            return {
                ...state,
                restrictedAccounts: action.payload,
            };
        case CREATE_RESTRICTED_ACCOUNT:
            const data = [...state.restrictedAccounts];
            data.unshift(action.payload);
            return {
                ...state,
                restrictedAccounts: data,
            };
        case UPDATE_RESTRICTED_ACCOUNT_STATUS:
            return {
                ...state,
                restrictedAccounts: state.restrictedAccounts.map((restrictedAccount) => {
                    if (restrictedAccount._id === action.payload.id) return action.payload.data;
                    else return restrictedAccount;
                }),
            };
        case DELETE_RESTRICTED_ACCOUNT:
            return {
                ...state,
                restrictedAccounts: state.restrictedAccounts.filter(
                    (restrictedAccount) => restrictedAccount._id !== action.payload
                ),
            };
        case OPEN_RESTRICTED_ACCOUNT_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };
        case CLOSE_RESTRICTED_ACCOUNT_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };

        default:
            return state;
    }
};

export default restrictedAccountReducer;
